import { render, staticRenderFns } from "./eeactivity.vue?vue&type=template&id=0bf5aaf4&"
import script from "./eeactivity.vue?vue&type=script&lang=js&"
export * from "./eeactivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bf5aaf4')) {
      api.createRecord('0bf5aaf4', component.options)
    } else {
      api.reload('0bf5aaf4', component.options)
    }
    module.hot.accept("./eeactivity.vue?vue&type=template&id=0bf5aaf4&", function () {
      api.rerender('0bf5aaf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/communityPartyBuilding/registrationInformation/eeactivity.vue"
export default component.exports